import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Option from 'muicss/lib/react/option';
import Select from 'muicss/lib/react/select';
import Progress from 'react-progressbar';
import Loader from 'halogen/ScaleLoader';

export default class TestStatus extends React.Component {
  render() {
    let finished = this.props.finished;
    let lastStatusLevel = null;

    if (this.props.events) {
      lastStatusLevel = this.props.events[this.props.events.length-1].level;
    }

    let progressColor = "#6ab8f7";
    if (finished) {
      if (lastStatusLevel == "success") {
        progressColor = "green";
      } else {
        progressColor = "#F44336";
      }
    }

    return <Panel className="mui--text-center">
      <div className="mui--text-center">
        {
          finished ? 
            (lastStatusLevel == "success") ?
              <i className="material-icons status-icon success">done</i>
              :
              <i className="material-icons status-icon error">bug_report</i>
          :
          <Loader className="spinner" color="#2196f3" size="60px" margin="4px" />
        }
      </div>
      <div className="mui--text-title status">{this.props.main_status ? this.props.main_status : "Loading..."}</div>
      <Progress completed={this.props.progress} height="3px" color={progressColor} />
    </Panel>
  }
}



// WEBPACK FOOTER //
// ./src/components/TestStatus.js